import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { AdminContextProvider } from '../../../context/admin-context';
import { FeeDisclaimerConfig } from './fee-disclaimer-config';

export function initFeeDisclaimerConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('fee-disclaimer-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        root.render(
          v2Component(
            <AdminContextProvider>
              <FeeDisclaimerConfig />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
